module.exports = __webpack_public_path__ + "img/image106.acc55d12.jpg";